// packages/shared-hooks/src/auth/useLogout.ts
// Pure API mutation. Store clearing + navigation are web-specific side
// effects wired by the consumer (the web ProfileMenu). Mobile
// will wire its own equivalents. No cross-app imports here.
import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../api/context.js';

export function useLogout() {
  const client = useApiClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => client.post<void>('/auth/logout'),
  });
}
